import type { MotorP } from "../../tip";

/**
 * Türkçe sözlük · motor mesajları · deger. Anahtar motorun `mm("kod", …)`
 * çağrısındaki koddur; değer, mesajın değerlerinden cümleyi kurar.
 */
export const deger = {
  // --- ortak parçalar ------------------------------------------------------
  "deger.sebepBilinmiyor": () => "sebep bilinmiyor",
  "deger.motorSebepSoylemedi": () => "motor sebebini söylemedi",
  "deger.ikiSebep": (p: MotorP) => `${p.a}; ${p.b}`,
  "deger.parantezListe": (p: MotorP) => ` (${p.varliklar})`,
  "deger.eksikAralik": (p: MotorP) => `${p.bas}..${p.son} (${p.sebep})`,
  "deger.payBasina": (p: MotorP) => ` (pay başına ${p.tutar})`,
  "deger.bolunmeOrani": (p: MotorP) => ` (${p.pay}:${p.payda})`,
  "deger.yalnizDegerli": (p: MotorP) => `; yalnızca değeri olan: ${p.varliklar}`,
  "deger.yalnizMaliyetli": (p: MotorP) => `; yalnızca maliyeti olan: ${p.varliklar}`,
  "deger.adMevcutGetiri": () => "Mevcut getiri",
  "deger.adGerceklesmisGetiri": () => "Gerçekleşmiş getiri",
  "deger.adAcikMaliyet": () => "Açık maliyet",

  // --- FIFO damgaları ------------------------------------------------------
  "deger.devirMaliyetiYok": () =>
    "devir alınan miktarın birim maliyeti girilmemiş; maliyet sıfır SAYILMADI, " +
    "kazanç bu parti tüketildiğinde eksik kalır",
  "deger.olceklemePartisiz": (p: MotorP) =>
    `${p.tur} kaydı var ama o tarihte açık parti yok — kasada daha eski bir alış eksik olabilir`,
  "deger.fazlaSatis": (p: MotorP) =>
    `satılan miktarın ${p.miktar} kadarının karşılığı kasada yok — maliyet UYDURULMADI, bu kadarı maliyetsiz bırakıldı`,
  "deger.karisikParaBirimi": (p: MotorP) =>
    `bu araçta ${p.pbler} hareketleri birlikte var; toplam maliyet tek para biriminde verilemiyor`,

  // --- değerleme damgaları -------------------------------------------------
  "deger.elleFiyatYoksayildi": (p: MotorP) =>
    `bu araç izlemede ve günlük fiyatı kaynaktan geliyor; elle girilen ${p.tarih} fiyatı KULLANILMADI`,
  "deger.fiyatYokAralik": (p: MotorP) =>
    `${p.tarih} ve öncesinde bu araç için hiç fiyat yok; eksik aralık: ${p.araliklar}`,
  "deger.fiyatYokOnbellekBos": (p: MotorP) => `${p.tarih} ve öncesinde bu araç için hiç fiyat yok; önbellek boş`,
  "deger.paraBirimiCeliskisi": (p: MotorP) =>
    `fiyat ${p.fiyatPb} cinsinden, hareketler ${p.hareketPb} cinsinden; piyasa değeri fiyatın para biriminde hesaplandı`,
  "deger.bedelsizRuchanBilinmiyor": (p: MotorP) =>
    `bedelsiz ve rüçhan bu araç için hiçbir kaynakta yok (${p.kaynak}); ` +
    "adet ve maliyet yalnızca kasadaki BONUS/RIGHTS satırlarına dayanıyor",
  "deger.kaydedilmemisTemettu": (p: MotorP) =>
    `kaynakta ${p.tarih} hak kullanım günlü temettü var${p.payBasina}; kasada ${p.bas}..${p.son} ` +
    "arasında DIVIDEND satırı yok — nakit akışı ve getiri bu kadar eksik",
  "deger.kaydedilmemisBolunme": (p: MotorP) =>
    `kaynakta ${p.tarih} tarihli bölünme var${p.oran}; kasada ${p.bas}..${p.son} arasında ` +
    "SPLIT/BONUS satırı yok — adet, dolayısıyla piyasa değeri yanlış olabilir",
  "deger.paraBirimiTaninmiyor": (p: MotorP) =>
    `"${p.kod}" tanınan bir para birimi kodu DEĞİL; kuru hiçbir kaynakta ` +
    "aranamaz, bu yüzden bu varlığın maliyeti ve kazancı çıkmayabilir" +
    ". Kasadaki bu satırları listeden seçilebilen bir kodla düzeltin.",
  "deger.paraBirimiTaninmiyorTahmin": (p: MotorP) =>
    `"${p.kod}" tanınan bir para birimi kodu DEĞİL; kuru hiçbir kaynakta ` +
    "aranamaz, bu yüzden bu varlığın maliyeti ve kazancı çıkmayabilir" +
    `. Muhtemelen "${p.tahmin}" kastedilmiş — kasadaki bu satırları düzeltin.`,
  "deger.kurYokParti": (p: MotorP) =>
    `${p.kaynak}/${p.hedef} kuru ${p.tarih} için yok; bu partinin maliyeti rapor para birimine çevrilemedi`,
  "deger.kurYokPartiSebep": (p: MotorP) =>
    `${p.kaynak}/${p.hedef} kuru ${p.tarih} için yok — o günkü partinin maliyeti çevrilemedi`,
  "deger.kurYokSatis": (p: MotorP) =>
    `${p.kaynak}/${p.hedef} kuru ${p.tarih} için yok; bu satışın kazancı rapor para birimine çevrilemedi`,
  "deger.kurYokSatisSebep": (p: MotorP) =>
    `${p.kaynak}/${p.hedef} kuru ${p.tarih} için yok — o günkü satışın kazancı çevrilemedi`,
  "deger.sermayeHaric": (p: MotorP) =>
    `${p.adet} sermaye hareketi (yatırma/çekme) getiriye GİRMİYOR: ` +
    "hesaba para koymak kazanç değildir. Nakit bakiyesi ayrı bir sorudur",
  "deger.nakitTutarOkunamadi": (p: MotorP) =>
    `${p.tur} satırında miktar × fiyat sıfır çıkıyor ama fiyat ${p.fiyat}: ` +
    'nakit satırının kodlaması quantity = "1", price = tutar olmalı. ' +
    "Bu satır nakit akışına KATILMADI",
  "deger.kurYokKisa": (p: MotorP) => `${p.kaynak}/${p.hedef} kuru ${p.tarih} için yok`,
  "deger.kurYokNakit": (p: MotorP) =>
    `${p.kaynak}/${p.hedef} kuru ${p.tarih} için yok; bu nakit hareketi rapor para birimine çevrilemedi`,
  "deger.satirOkunamadiMiktarsiz": (p: MotorP) => `${p.adet} satırın tutarı okunamadı (miktar yazılmamış)`,
  "deger.kapaliSatisli": () => "açık parti kalmadı; yalnızca gerçekleşmiş kazanç raporlanıyor",
  "deger.kapaliSatissiz": () =>
    "bu varlıkta açık parti YOK ve satış da yok — kasada yalnızca miktar taşımayan hareketler var",
  "deger.elleDegerYokNot": (p: MotorP) =>
    `"${p.etiket}" için ${p.tarih} ve öncesinde ne birim fiyat ne toplam değer girilmiş; değer UYDURULMADI`,
  "deger.kurYokDeger": (p: MotorP) =>
    `${p.kaynak}/${p.hedef} kuru ${p.tarih} için yok; değer aracın para biriminde var, rapor para biriminde YOK`,
  "deger.maliyetBilinmeyenParti": () =>
    "açık partilerden en az birinin maliyeti bilinmiyor (fiyatsız devir); kazanç EKSİK, sıfır sayılmadı",
  "deger.kurYokCift": (p: MotorP) => `${p.kaynak}/${p.hedef} kuru yok`,
  "deger.elleDegerGirilmemis": () => "elle değer girilmemiş",
  "deger.fiyatYok": () => "fiyat yok",
  "deger.kovaSatirOkunamadi": (p: MotorP) =>
    `${p.adet} satırın tutarı okunamadı (${p.kimlikler}): ` +
    "quantity × price sıfır ama price sıfır değil. Bu kovanın neti hesaplanamıyor",
  "deger.satirOkunamadi": (p: MotorP) => `${p.adet} satırın tutarı okunamadı`,
  "deger.kovaCevrilemedi": (p: MotorP) =>
    `${p.kaynak} → ${p.hedef} kuru ${p.tarih} gününde bulunamadı. ` +
    "Kovanın kendi para birimindeki neti DOĞRU ve yayımlandı",
  "deger.kovaKurYok": (p: MotorP) => `${p.kaynak} → ${p.hedef} kuru yok`,
  "deger.toplamMaliyetEksik": (p: MotorP) =>
    `maliyet toplamı EKSİK: ${p.varliklar} rapor para birimine çevrilemedi (kur yok)`,
  "deger.toplamKazancEksik": (p: MotorP) =>
    `gerçekleşmiş kazanç toplamı EKSİK: ${p.varliklar} satışları rapor para birimine çevrilemedi`,
  "deger.toplamNakitEksik": (p: MotorP) =>
    `nakit akışı toplamı EKSİK: ${p.varliklar} nakit hareketleri ` +
    "rapor para birimine çevrilemedi ya da tutarı okunamadı",
  "deger.toplamGetiriVerilmedi": () =>
    "gerçekleşmiş getiri TOPLAMI verilmedi: bileşenlerinden en az biri " +
    "(gerçekleşmiş kazanç ya da nakit akışı) bir varlıkta ölçülemedi — " +
    "pozisyon satırlarındaki getiriler geçerli",
  "deger.toplamKazancKapsam": (p: MotorP) =>
    "gerçekleşmemiş kazanç TOPLAMI verilmedi: değer ve maliyet toplamlarının " +
    `kapsamı aynı değil${p.yalnizDeger}${p.yalnizMaliyet} — pozisyon satırlarındaki kazançlar geçerli`,
  "deger.nakitHareketleriCevrilemedi": (p: MotorP) =>
    `${p.varliklar} nakit hareketleri çevrilemedi ya da okunamadı`,

  // --- yokluk sebepleri: pay -----------------------------------------------
  "deger.payEksiDeger": () => "Kapsamda eksi değerli bir varlık var: değere göre pay hesaplanamaz.",
  "deger.payToplamSifir": () => "Kapsamdaki değerlerin toplamı sıfır: pay hesaplanamaz.",
  "deger.payEldeKalmadi": () => "Elde kalmadı: payı yok.",
  "deger.payDegerOlculemedi": () =>
    "Değeri ölçülemediği için payı hesaplanamadı; öteki varlıkların payları ölçülebilenlerin toplamına göre.",
  "deger.payHesaplanamadi": () => "Pay hesaplanamadı.",

  // --- yokluk sebepleri: geçmiş dahil getiri -------------------------------
  "deger.bilesenOlculemedi": (p: MotorP) => `${p.ad}: ${p.sebep}`,
  "deger.getiriHicYok": () => "Elde varlık da, satış da, temettü/faiz/masraf da yok: getiri yok.",
  "deger.getiriYokKisa": () => "Getiri yok.",
  "deger.satilanMaliyetEksik": () => "Satılan partilerin maliyeti eksik: oran verilmedi.",
  "deger.cepMaliyetSifir": () => "Cepten çıkan maliyet sıfır: oran yok.",

  // --- yokluk sebepleri: yıllık karşılık -----------------------------------
  "deger.maliyetSifirOranYok": () => "Maliyet sıfır: oran yok.",
  "deger.getiriOlculemedi": () => "Getiri ölçülemedi.",
  "deger.yasHesaplanamadi": () => "Partilerin maliyeti çevrilemedi: yaş hesaplanamadı.",
  "deger.yasKisa": (p: MotorP) =>
    `Ağırlıklı yaş ${p.yas} gün: ${p.min} günden kısa sürede yıllığa çevirmek yanıltır.`,
  "deger.yillikHesaplanamadi": () => "Yıllık karşılık hesaplanamadı.",
  "deger.eldePartiYokYillik": () => "Elde parti yok: yıllık karşılık eldeki partilerden hesaplanır.",
  "deger.eldePartiYok": () => "Elde parti yok.",
  "deger.maliyetsizPartiOran": () => "Maliyeti bilinmeyen parti var (fiyatsız devir): oran verilmez.",
  "deger.maliyetsizPartiYas": () => "Maliyeti bilinmeyen parti var: ağırlıklı yaş verilmez.",
  "deger.nakitOlculemediOran": () => "Temettü/faiz/masraf ölçülemedi: getiri eksik kalırdı.",
  "deger.gerceklesmemisYok": (p: MotorP) => `Gerçekleşmemiş kazanç yok: ${p.sebep}.`,
  "deger.degerYaDaMaliyetEksik": () => "değer ya da maliyet eksik",
  "deger.partiMaliyetiCevrilemedi": () => "Partilerin maliyeti çevrilemedi.",
  "deger.eksikToplamYillik": () => "Bazı pozisyonlar değerlenemedi: eksik toplamdan yıllık karşılık verilmez.",
  "deger.yasPartiEksik": () => "Bir partinin maliyeti çevrilemedi ya da bilinmiyor: ağırlıklı yaş verilmez.",
  "deger.partiYokYas": () => "Parti yok: ağırlıklı yaş yok.",

  // --- yokluk sebepleri: nakit akışı ---------------------------------------
  "deger.nakitSatiriDustu": () => "bir nakit satırı düştü",
  "deger.gelirOlculemedi": (p: MotorP) => `Gelir ölçülemedi: ${p.sebep}. Kalan satırlar toplanmadı.`,
  "deger.giderOlculemedi": (p: MotorP) => `Gider ölçülemedi: ${p.sebep}. Kalan satırlar toplanmadı.`,
  "deger.netNakitOlculemedi": (p: MotorP) => `Net nakit akışı ölçülemedi: ${p.sebep}. Kalan satırlar toplanmadı.`,
  "deger.gelirYokVarlik": () => "Bu varlıkta temettü ya da faiz geliri yok.",
  "deger.gelirYokKasa": () => "Kasada temettü ya da faiz geliri yok.",
  "deger.giderYokVarlik": () => "Bu varlıkta masraf yok.",
  "deger.giderYokKasa": () => "Kasada masraf yok.",

  // --- yokluk sebepleri: pozisyon ------------------------------------------
  "deger.kapaliDegerYok": () => "Kapalı pozisyon: elde adet kalmadı, değerlenecek bir şey yok.",
  "deger.kapaliFiyatSorulmadi": () => "Kapalı pozisyon: elde adet kalmadı, fiyat sorulmadı.",
  "deger.elleToplamDeger": () => "Elle TOPLAM değer girilmiş: birim fiyat yok, değer doğrudan o kayıttan.",
  "deger.elleHicbiriYok": () => "Elle ne birim fiyat ne toplam değer girilmiş.",
  "deger.fiyatYokKasada": () => "Fiyat yok: bu tarih ve öncesi için kasada bu aracın fiyatı yok.",
  "deger.degerlenemedi": (p: MotorP) => `Değerlenemedi: ${p.sebep}. Toplama GİRMEDİ.`,
  "deger.acikPartiYok": () => "Açık parti yok: maliyeti taşınan bir şey kalmadı.",
  "deger.maliyetCevrilemedi": (p: MotorP) => `Maliyet çevrilemedi: ${p.sebep}.`,
  "deger.kapaliKazancYok": () => "Kapalı pozisyon: gerçekleşmemiş kazanç yok — elde bir şey kalmadı.",
  "deger.degerYokKazancSayilmadi": (p: MotorP) => `Değer yok (${p.sebep}) — kazanç sıfır SAYILMADI.`,
  "deger.maliyetYokKazancSayilmadi": (p: MotorP) => `Maliyet çevrilemedi (${p.sebep}) — kazanç sıfır SAYILMADI.`,
  "deger.satisKazanciCevrilemedi": (p: MotorP) => `Satış var ama kazancı çevrilemedi: ${p.sebep}.`,
  "deger.satisYok": () => "Satış yok: gerçekleşmiş kazanç ancak bir satışla doğar.",
  "deger.nakitAkisiOlculemediSebep": (p: MotorP) => `Nakit akışı ölçülemedi: ${p.sebep}.`,
  "deger.varliktaNakitYok": () => "Bu varlıkta temettü, faiz ya da masraf hareketi yok.",
  "deger.kazancOlculemediYarim": () => "Gerçekleşmiş kazanç ölçülemedi — yarısı eksik bir getiri gösterilmez.",
  "deger.nakitOlculemediYarim": () => "Nakit akışı ölçülemedi — yarısı eksik bir getiri gösterilmez.",
  "deger.gerceklesmisGetiriYok": () => "Satış da temettü/faiz/masraf da yok: gerçekleşmiş getiri yok.",

  // --- yokluk sebepleri: asıl getiri ---------------------------------------
  "deger.nakitIzlenmiyor": () =>
    "Nakit izlenmiyor (Ayarlar › Nakit takibi: Kapalı): asıl getiri nakitle hesaplanır.",
  "deger.kasadaHareketYok": () => "Kasada hareket yok.",
  "deger.asilEksikDeger": () => "Bazı pozisyonlar değerlenemedi: eksik değerden asıl getiri verilmez.",
  "deger.asilTutarOkunamadi": (p: MotorP) => `${p.id} hareketinin tutarı okunamadı: asıl getiri hesaplanamadı.`,
  "deger.asilKurYokAkis": (p: MotorP) =>
    `${p.kaynak}/${p.hedef} kuru ${p.tarih} için yok: para akışı çevrilemedi.`,
  "deger.asilKurYokNakit": (p: MotorP) => `${p.kaynak}/${p.hedef} kuru ${p.tarih} için yok: nakit çevrilemedi.`,
  "deger.netYatirilanSifirEksi": () => "Yatırılan − çekilen sıfır ya da eksi: oran yok.",
  "deger.netYatirilanSifir": () => "Yatırılan − çekilen sıfır: oran yok.",
  "deger.paraYasHesaplanamadi": () => "Para ağırlıklı yaş hesaplanamadı.",
  "deger.paraYasKisa": (p: MotorP) =>
    `Para ağırlıklı yaş ${p.yas} gün: ${p.min} günden kısa sürede yıllığa çevirmek yanıltır.`,
  "deger.paraYasSifir": () => "Para ağırlıklı yaş sıfır.",

  // --- yokluk sebepleri: rapor toplamları ----------------------------------
  "deger.hicDegerlenemedi": () => "Hiçbir pozisyon değerlenemedi. Dışlananlar sebepleriyle yukarıda listeli.",
  "deger.acikPozisyonYok": () => "Açık pozisyon yok: değerlenecek bir şey yok.",
  "deger.hicMaliyetCevrilemedi": (p: MotorP) =>
    `Hiçbir açık partinin maliyeti rapor para birimine çevrilemedi${p.liste} — kur yok.`,
  "deger.acikPozisyonKazancYok": () => "Açık pozisyon yok: gerçekleşmemiş kazanç yok.",
  "deger.kapsamFarkli": () =>
    "Değer ve maliyet toplamlarının kapsamı aynı değil — tutarsız bir toplam " +
    "yayımlanmadı. Pozisyon satırlarındaki kazançlar geçerli.",
  "deger.hicDegerMaliyetYok": () => "Hiçbir pozisyonda hem değer hem maliyet yok — kazanç sıfır SAYILMADI.",
  "deger.hicSatisCevrilemedi": (p: MotorP) =>
    `Satışların hiçbiri rapor para birimine çevrilemedi${p.liste} — kur yok.`,
  "deger.nakitOlculemediToplam": (p: MotorP) =>
    `Nakit akışı ölçülemedi${p.liste}: kur yok ya da tutarı okunamayan satır var.`,
  "deger.kasadaNakitYok": () => "Kasada temettü, faiz ya da masraf yok.",
  "deger.toplamGetiriBilesenDustu": () =>
    "Bileşenlerinden biri (gerçekleşmiş kazanç ya da nakit akışı) bir varlıkta " +
    "ölçülemedi — yarısı eksik bir getiri gösterilmez. Pozisyon satırlarındaki " +
    "getiriler geçerli.",
  "deger.kesintiOlculemedi": () =>
    "Kesinti bilgisi taşıyan hareketler ölçülemedi: kur yok ya da tutarı okunamayan satır var.",
  "deger.kesintiYok": () => "Satış ya da temettü/faiz hareketi yok: kesinti bilgisi taşıyan hareket yok.",
  "deger.nakitTakibiKapali": () => "Nakit takibi kapalı (Ayarlar).",
  "deger.kasadaHicHareketYok": () => "Kasada hiç hareket yok.",
  "deger.kovaToplamaGiremedi": () =>
    "Kovalardan biri toplama giremedi — eksik toplam yayımlanmaz. Hangisi olduğu " +
    "aşağıdaki nakit tablosunda.",

  // --- yokluk sebepleri: günlük getiri -------------------------------------
  "deger.oncekiGetiriOlculemedi": (p: MotorP) => `${p.gun} getirisi ölçülemedi: ${p.sebep}`,
  "deger.gunlukDayanakYok": () => "Günlük getirinin dayanağı yok.",
  "deger.oncekiDegerOlculemedi": (p: MotorP) => `${p.gun} değeri ölçülemedi: ${p.sebep}`,
  "deger.oncekiGunEldeYok": (p: MotorP) => `${p.gun} günü elde yoktu: günlük yüzde yok.`,
  "deger.oncekiGunDegerSifir": (p: MotorP) => `${p.gun} günü değer sıfırdı: günlük yüzde yok.`,
  "deger.eksikToplamGunluk": () => "Bazı pozisyonlar değerlenemedi: eksik toplamdan günlük getiri verilmez.",
} satisfies Record<string, (p: MotorP) => string>;
